module.exports = __webpack_public_path__ + "media/images/sme-package-efbbfec619f2dd7acd647836105a3fe9.png";